<template>
  <div class="team-page">
    <nav class="breadcrumb">
      <router-link class="breadcrumb__link" to="/">{{ breadcrumb.home }}</router-link>
      <span class="breadcrumb__separator">/</span>
      <span class="breadcrumb__current">{{ breadcrumb.current }}</span>
    </nav>

    <!-- <header class="team-page__intro">
      <h1>{{ intro.title }}</h1>
      <p>{{ intro.description }}</p>
    </header> -->

    <section
      v-for="(section, sectionIndex) in rosterWithCount"
      :key="section.heading || sectionIndex"
      class="team-section"
    >
      <h2 class="heading-with-bar">
        {{ section.heading }}
        <span v-if="section.count" class="team-section__count">（{{ section.count }}）</span>
      </h2>
      <div class="team-grid">
        <article
          v-for="member in section.members"
          :key="member.slug || member.name"
          :class="['member-card', { 'member-card--link': hasMemberProfile(member.slug) }]"
        >
          <component
            :is="hasMemberProfile(member.slug) ? 'router-link' : 'div'"
            v-bind="linkProps(member)"
            class="member-card__content"
          >
            <div
              :class="[
                'member-card__avatar',
                {
                  'member-card__avatar--loading':
                    !isImageReady(memberId(member)) && !hasImageError(memberId(member)),
                  'member-card__avatar--error': hasImageError(memberId(member)),
                },
              ]"
            >
              <img
                v-lazy="member.image"
                :alt="`${member.name} portrait`"
                loading="lazy"
                :class="{ 'is-visible': isImageReady(memberId(member)) }"
                @load="handleImageLoad(memberId(member))"
                @error="handleImageError(memberId(member), $event)"
              />
            </div>
            <div class="member-card__body">
              <h3>{{ member.name }}</h3>
              <p class="member-card__title">{{ member.title }}</p>
              <p v-if="member.note" class="member-card__note">{{ member.note }}</p>
            </div>
          </component>
        </article>
      </div>
    </section>

    <!-- <section v-if="alumni.people.length" class="alumni">
      <h2 class="heading-with-bar">
        {{ alumni.heading }}
        <span class="team-section__count">（{{ alumni.people.length }}）</span>
      </h2>
      <div class="alumni-table">
        <header class="alumni-table__header">
          <span>{{ alumni.columns.name }}</span>
          <span>{{ alumni.columns.role }}</span>
          <span>{{ alumni.columns.period }}</span>
          <span>{{ alumni.columns.destination }}</span>
        </header>
        <div
          v-for="(person, personIndex) in alumni.people"
          :key="person.name || personIndex"
          class="alumni-table__row"
        >
          <span
            class="alumni-table__cell alumni-table__cell--name"
          >
            {{ person.name }}
          </span>
          <span
            class="alumni-table__cell alumni-table__cell--role"
          >
            {{ person.role }}
          </span>
          <span
            class="alumni-table__cell alumni-table__cell--period"
          >
            {{ person.period }}
          </span>
          <span
            class="alumni-table__cell alumni-table__cell--destination"
          >
            {{ person.destination }}
          </span>
        </div>
      </div>
    </section> -->
  </div>
</template>

<script>
import { getLocaleBlock } from '@/utils/i18n';
import { envConfig } from '@/config/env';

const FALLBACK_AVATAR = `${envConfig.cdnBase}/people.png`;

export default {
  name: 'TeamView',
  data() {
    return {
      imageStates: {},
    };
  },
  computed: {
    page() {
      return getLocaleBlock(this.$i18n, 'membersPage', {}) || {};
    },
    breadcrumb() {
      const crumb = this.page.breadcrumb || {};
      return {
        home: crumb.home || 'Home',
        current: crumb.current || 'Members',
      };
    },
    intro() {
      const intro = this.page.intro || {};
      return {
        title: intro.title || 'Members',
        description: intro.description || '',
      };
    },
    profileMap() {
      const profiles = this.page.profiles;
      return profiles && typeof profiles === 'object' ? profiles : {};
    },
    roster() {
      const list = this.page.roster;
      return Array.isArray(list) ? list : [];
    },
    rosterWithCount() {
      return this.roster.map((section) => {
        const members = Array.isArray(section.members) ? section.members : [];
        return { ...section, members, count: members.length };
      });
    },
    alumni() {
      const alumni = this.page.alumni || {};
      const people = Array.isArray(alumni.people) ? alumni.people : [];
      const columns = alumni.columns || {};
      return {
        heading: alumni.heading || 'Alumni',
        columns: {
          name: columns.name || 'Name',
          role: columns.role || 'Role',
          period: columns.period || 'Period',
          destination: columns.destination || 'Current',
        },
        people,
      };
    },
  },
  methods: {
    hasMemberProfile(slug) {
      console.log(slug);
      
      return true
      
      // return Boolean(slug && this.profileMap[slug]);
    },
    linkProps(member) {
      if (this.hasMemberProfile(member.slug)) {
        return {
          to: {
            name: 'MemberDetail',
            params: { slug: member.slug },
          },
        };
      }
      return {};
    },
    memberId(member) {
      return member.slug || member.name || '';
    },
    isImageReady(id) {
      return this.imageStates[id] === 'loaded';
    },
    hasImageError(id) {
      return this.imageStates[id] === 'error';
    },
    handleImageLoad(id) {
      this.$set(this.imageStates, id, 'loaded');
    },
    handleImageError(id, event) {
      const img = event?.target;
      if (img && img.dataset.fallbackApplied !== 'true') {
        img.dataset.fallbackApplied = 'true';
        img.src = FALLBACK_AVATAR;
        return;
      }
      this.$set(this.imageStates, id, 'error');
    },
  },
};
</script>

<style scoped>
.team-page {
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
  max-width: 1400px;    
  margin-right: auto;
  margin-left: auto;
}

.breadcrumb {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-size: 0.95rem;
  color: #5a6783;
}

.breadcrumb__link {
  color: inherit;
  text-decoration: none;
}

.breadcrumb__link:hover {
  color: #1f4cff;
}

.breadcrumb__separator {
  color: #a3afc7;
}

.breadcrumb__current {
  font-weight: 600;
  color: #1d2e4a;
}

.team-page__intro h1 {
  font-size: 2rem;
  color: #172941;
  margin-bottom: 0.8rem;
}

.team-page__intro p {
  color: #55627a;
  line-height: 1.7;
  max-width: 760px;
}

.team-section__count {
  font-size: 1rem;
  color: #4b5872;
  margin-left: 0.4rem;
}

.team-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 320px));
  gap: 1.6rem;
  justify-content: center;
}

.member-card {
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 18px 44px rgba(27, 51, 90, 0.12);
  border: 1px solid rgba(27, 51, 90, 0.08);
  display: flex;
  flex-direction: column;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.member-card__content {
  display: flex;
  flex-direction: column;
  height: 100%;
  text-decoration: none;
  color: inherit;
}

.member-card--link .member-card__content {
  cursor: pointer;
}

.member-card--link:hover {
  transform: translateY(-4px);
  box-shadow: 0 22px 50px rgba(27, 51, 90, 0.16);
}

.member-card__avatar {
  width: 100%;
  aspect-ratio: 4 / 5;
  background: #fff;
  overflow: hidden;
  position: relative;
}

.member-card__avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  opacity: 0;
  transition: opacity 0.35s ease;
}

.member-card__avatar img.is-visible {
  opacity: 1;
}

.member-card__avatar--loading {
  background: #fff;
}

.member-card__avatar--loading::after {
  content: '';
  position: absolute;
  inset: 0;
  margin: auto;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  border: 3px solid rgba(255, 255, 255, 0.75);
  border-top-color: #1f55bf;
  box-shadow: 0 10px 24px rgba(31, 85, 191, 0.12);
  animation: spin 0.9s linear infinite;
}

.member-card__avatar--error {
  background: linear-gradient(135deg, #fbeaea 0%, #fff5f5 100%);
  border-bottom: 1px solid rgba(198, 68, 68, 0.28);
}

.member-card__body {
  padding: 1.2rem 1.4rem 1.4rem;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.member-card__body h3 {
  margin: 0;
  font-size: 1.05rem;
  color: #14233c;
}

.member-card__title {
  margin: 0;
  color: #4c5a74;
  font-weight: 600;
}

.member-card__note {
  margin: 0;
  color: #6a7793;
  font-size: 0.9rem;
}

.alumni h2 {
  font-size: 1.5rem;
  color: #1f3150;
  margin-bottom: 1.2rem;
}

.alumni-table {
  background: #fff;
  border-radius: 20px;
  border: 1px solid rgba(28, 47, 80, 0.08);
  box-shadow: 0 18px 44px rgba(27, 51, 90, 0.12);
  overflow: hidden;
}

.alumni-table__header,
.alumni-table__row {
  display: grid;
  grid-template-columns: 1.3fr 1fr 1fr 1.4fr;
  gap: 1rem;
  padding: 1rem 1.4rem;
  align-items: center;
}

.alumni-table__header {
  background: linear-gradient(135deg, rgba(31, 76, 255, 0.1), rgba(31, 76, 255, 0));
  font-weight: 600;
  color: #1d2e4a;
}

.alumni-table__row {
  color: #4d5f7c;
  border-top: 1px solid rgba(28, 47, 80, 0.06);
}

.alumni-table__cell {
  display: block;
  overflow-wrap: break-word;
  word-break: normal;
}

.alumni-table__cell--destination {
  display: flex;
  align-items: center;
  gap: 0.45rem;
}

.alumni-table__cell--destination::before {
  content: '→';
  font-weight: 600;
  color: #1f4cff;
}

.alumni-table__row:nth-child(even) {
  background: rgba(244, 247, 255, 0.65);
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@media (max-width: 640px) {
  .team-grid {
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  }

  .alumni-table__header,
  .alumni-table__row {
    grid-template-columns: minmax(0, 1.15fr) minmax(0, 1fr);
    gap: 0.6rem 1.1rem;
    align-items: start;
  }

  .alumni-table__row {
    padding: 1rem 1.2rem 1.2rem;
  }

  .alumni-table__header span:nth-child(1),
  .alumni-table__row .alumni-table__cell--name,
  .alumni-table__header span:nth-child(3),
  .alumni-table__row .alumni-table__cell--period {
    grid-column: 1;
  }

  .alumni-table__header span:nth-child(2),
  .alumni-table__row .alumni-table__cell--role,
  .alumni-table__header span:nth-child(4),
  .alumni-table__row .alumni-table__cell--destination {
    grid-column: 2;
  }
}
</style>
